module.exports = __webpack_public_path__ + "img/whats-new_cn.1eff960.jpg";